import Luff, {Dict, IObservableState, IObservableStateArray, IObservableStateSimple, TValueName} from "luff";

export interface ILocale {
    Locale: string;
    Messages: Dict<string>;
    //Lists: Map<TValueName<number>[], TValueName<number>[]>;
}


export function getPluralText(n: number, locale: string, key: string): string {
    const pluralPack = L10n._PluralPacks[locale];
    if (!pluralPack)
        return key;
    const pluralSet = pluralPack.PluralSetByKey[key];
    if (!pluralSet)
        return key;

    let p = pluralPack.IntlPluralRules.select(n);
    return pluralSet[p];
}


type TPluralSet = {
    one: string;
    few: string;
    many: string;
    other: string;
}
type TPluralPack = {
    IntlPluralRules: Intl.PluralRules;
    PluralSetByKey: Dict<TPluralSet>;
}
type TOnReadyCallBack = () => void;

const messages = Luff.State<Dict<string>>({});

enum CASE {
    Lower = "Lower",
    Upper = "Upper",
    Capitalize = "Capitalize"
}
const REGEX_TPL_PARAM = /\$\d/;

export class L10n {
    public static CASE = CASE;
    public static LocaleDictionaries : Dict<ILocale> = {};

    public static CurrentLocale = Luff.State<ILocale>({
        Locale: '',
        Messages: {},
        //Lists: new Map<TValueName<number>[], TValueName<number>[]>()
    });
    public static _PluralPacks: Dict<TPluralPack> = {};

    private static OnReadyList: TOnReadyCallBack[] = [];
    private static StaticListsMapDict = new Map<TValueName<number>[], Dict<TValueName<number>[]>>();


    public static AddOnReady(cb: TOnReadyCallBack) {
        L10n.OnReadyList.push(cb)
    }
    public static LoadLocale(locale: string) : Promise<ILocale> {
        return Promise.resolve()
            .then(_ => {
                const loc: ILocale = {
                    Locale: locale,
                    Messages: {}
                };
                L10n.LocaleDictionaries[locale] = loc;
                L10n.SetLocale(loc);
                if (L10n.OnReadyList) {
                    for (let cb of L10n.OnReadyList) {
                        cb();
                    }
                    delete L10n.OnReadyList;
                }
                return loc;
            })
    }
    public static SwitchLocale(locale: string): Promise<any> {
        if (L10n.LocaleDictionaries[locale]) {
            L10n.SetLocale(L10n.LocaleDictionaries[locale]);
            return Promise.resolve();
        }
        return L10n.LoadLocale(locale);
    }

    public static GetTemplate(textID, obj: IObservableStateSimple<any>[]) {
        let r: string = L10n.FindText(textID);
        obj.forEach(i => {
            r = r.replace(REGEX_TPL_PARAM, i.SValue ?? i)
        });
        return r;
    }


    // private static StaticListsMapDict = {
    //     "LibraryType": {
    //         "ru": [],
    //         "en": [],
    //     }
    // };




    public static AddPluralRule(locale: string, key: string, set: TPluralSet): void {
        if (!L10n._PluralPacks[locale]) {
            L10n._PluralPacks[locale] = {
                IntlPluralRules: new Intl.PluralRules(locale),
                PluralSetByKey: {
                    [key]: set
                }
            }
        }
        L10n._PluralPacks[locale].PluralSetByKey[key] = set;
    }
    public static AddStaticList(origin: TValueName<number>[], locale: string, list: TValueName<number>[]) : void {
        let curr : Dict<TValueName<number>[]> = L10n.StaticListsMapDict.get(origin);
        if (curr) {
            curr[locale] = list;
            return;
        }
        L10n.StaticListsMapDict.set(origin, {
            [locale]: list,
        });
    }

    public static GetPluralText(num: number, key: string): string {
        const currentLocale = L10n.CurrentLocale.SValue;
        return getPluralText(num, currentLocale.Locale, key);
    }

    public static GetText(text: string, textCase?: string): string {
        return L10n.FindText(text, textCase);
    }

    public static GetTextState(textID: string, textCase: string = "", tVar?): IObservableState<string> {
        let s: IObservableStateSimple<any> = L10n.CurrentLocale.Messages[textID];
        if (!s) {
            s = L10n.CurrentLocale.Messages;
        }

        function findTranslate() {
            return tVar ? L10n.GetTemplate(textID, tVar) : L10n.GetText(textID, textCase);
        }

        return s.SubState(findTranslate, [L10n.CurrentLocale.Locale]);
    }
    public static GetStateTranslate(textState: IObservableStateSimple<string>) : IObservableStateSimple<string> {
        return textState.SubState(t => L10n.GetText(t));
    }

    public static GetStaticList(origin: TValueName<number>[]) : TValueName<number>[] {
        const locale = L10n.CurrentLocale.Locale.SValue;
        const dict =  L10n.StaticListsMapDict.get(origin);
        if (dict && dict[locale])
            return dict[locale];
        return origin;


        //return L10n.CurrentLocale.Lists.SValue.get(origin) || origin;
    }
    public static GetStaticListState(origin: TValueName<number>[]) : IObservableStateArray<TValueName<number>> {
        return L10n.CurrentLocale.Locale.SubStateArr(locale => {
            const dict = L10n.StaticListsMapDict.get(origin);
            if (dict && dict[locale])
                return dict[locale];
            return origin;
        });

        // return L10n.CurrentLocale.Lists.SubStateArr(map => {
        //     let data = map.get(origin);
        //     if (!data)
        //         return origin;
        //     return data;
        // });
    }

    public static FindText(textID: string, textCase?: string): string {
        if (!textID) {
            return "???";
        }
        let messages = this.CurrentLocale.Messages.SValue;

        let message = messages[textID]
            || messages[textID.toUpperCase()]
            || messages[textID.toLocaleLowerCase()]
            || messages[textID.charAt(0).toUpperCase() + textID.slice(1).toLowerCase()]
            || textID;

        switch (textCase) {
            case this.CASE.Upper:
                return message.toUpperCase();
            case this.CASE.Lower:
                return message.toLowerCase();
            case this.CASE.Capitalize:
                return message.charAt(0).toUpperCase() + message.slice(1).toLowerCase();
        }

        return message;
    }


    private static SetLocale(locale: ILocale): void {
        L10n.CurrentLocale.SValue = locale;
        Luff.Culture.Current = locale.Locale == "RU" ? Luff.Culture.Dict["ru-Ru"] : Luff.Culture.Dict["en-Us"]
    }
}
window["L10n"] = L10n;
export { messages }